import React from "react"
import { connect } from "react-redux"
import {
  Dialog,
  Button,
  DialogContent,
  DialogActions,
  Typography,
  Divider,
  CircularProgress,
  TextField,
} from "@material-ui/core"
import PhoneInput from "../MaskedPhoneInput"
import { openSnackBar } from "../../actions/snack-bar"
import { sendPin, login } from "../../actions/authentication"
import { updateUser } from "../../actions/users"

class ClaimModal extends React.Component {
  state = {
    phone: "",
    spinSubmit: false,
    page: 1,
    pin: "",
    password: "",
  }

  close = () => {
    this.props.dispatch({
      type: "CLAIM_MODAL",
      payload: { open: false, user: {} },
    })
  }

  submit = () => {
    const { page } = this.state
    if (page === 1) {
      this.check()
    } else if (page === 2) {
      this.submitPin()
    } else {
      this.updatePassword()
    }
  }

  check = () => {
    const user = this.props.user,
      phone = this.state.phone.replace(/[() .^$]/g, ""),
      correct = user.phone.replace(/\+1/, "")
    if (correct === phone) {
      this.setState({ spinSubmit: true })
      this.props
        .dispatch(sendPin(user.phone))
        .then(res => {
          this.setState({ page: 2 })
          this.setState({ spinSubmit: false })
        })
        .catch(err => {
          this.setState({ spinSubmit: false })
          this.props.dispatch(
            openSnackBar({ message: "There was an error checking your pin" })
          )
        })
    } else {
      this.props.dispatch(openSnackBar({ message: "Incorrect Phone Number" }))
    }
  }

  submitPin = () => {
    const phone = this.props.user.phone
    this.setState({ spinSubmit: true })
    this.props
      .dispatch(
        login({
          phone,
          auth_code: this.state.pin,
        })
      )
      .then(res => {
        this.setState({ spinSubmit: false, page: 3 })
      })
      .catch(err => {
        this.props.dispatch(
          openSnackBar({
            message: "Pin number was incorrect",
          })
        )
        this.setState({ spinSubmit: false })
      })
  }

  updatePassword = () => {
    const { password } = this.state
    this.props.dispatch(updateUser(this.props.user.id, { password }))
    this.close()
    this.props.dispatch(openSnackBar({ message: "Password set" }))
    this.props.dispatch({ type: "PAY_MODAL", payload: true })
  }

  change = (e, name) => {
    this.setState({ [name]: e.target.value })
  }

  render() {
    const { spinSubmit, phone, page, pin, password } = this.state
    return (
      <Dialog open={this.props.open}>
        <DialogContent>
          <Typography variant="h5">
            {page === 1
              ? "Claim this Profile"
              : page === 2
                ? "Enter Your Pin"
                : "Create a password"}
          </Typography>
          <Divider />
        </DialogContent>
        <DialogContent>
          {page === 1 ? (
            <PhoneInput value={phone} onChange={e => this.change(e, "phone")} />
          ) : page === 2 ? (
            <div>
              <Typography variant="caption">
                We just texted you a pin. Enter it to proceed
              </Typography>
              <TextField
                fullWidth
                value={pin}
                onChange={e => this.change(e, "pin")}
                label="Pin"
              />
            </div>
          ) : (
            <div>
              {/* <Typography variant="caption">Create a password</Typography> */}
              <TextField
                fullWidth
                value={password}
                onChange={e => this.change(e, "password")}
                label="Password"
                type="password"
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close}>Close</Button>
          <Button
            onClick={this.submit}
            variant="contained"
            color="primary"
            disabled={spinSubmit}
          >
            Submit
            {spinSubmit && (
              <CircularProgress
                style={{ position: "absolute", width: "25px", height: "25px" }}
                color="secondary"
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
    return {
      open: state.claimModal.open,
      user: state.claimModal.user,
      history: state.history,
    }
  },
  connector = connect(mapStateToProps)

export default connector(ClaimModal)
